var map = {
	"./2Z7A1243.jpg": 1136,
	"./2Z7A1330.jpg": 9019,
	"./2Z7A1388_1.jpg": 5889,
	"./2Z7A1496.jpg": 2425,
	"./2Z7A1506.jpg": 3202,
	"./2Z7A1520.jpg": 2228,
	"./2Z7A1687.jpg": 9278,
	"./birthday_cake.jpg": 9502,
	"./colongue.jpg": 8696,
	"./duck.jpg": 9960,
	"./forest_1.jpg": 7163,
	"./forest_2.jpg": 6987,
	"./grass.jpg": 6215,
	"./nethan1.jpg": 783,
	"./portrait.jpg": 4460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4596;